import React, { useEffect, useState } from "react";
import GradientBlinds from './GradientBlinds';

function getWebflowDevice() {
  if (typeof window === "undefined") return "desktop";

  const w = window.innerWidth;

  if (w < 480) return "mobile-portrait";
  if (w < 768) return "mobile-landscape";
  return "tablet-desktop";
}

export default function App() {
  const [spotlightRadius, setSpotlightRadius] = useState(0.3);

  useEffect(() => {

    const update = () => {
      const device = getWebflowDevice();
      const isMobile_P = device === "mobile-portrait";
      const isMobile_L = device === "mobile-landscape";

      setSpotlightRadius(isMobile_P ? 0.18 : isMobile_L ? 0.2 : 0.3);
    };

    update(); // ✅ on load

    // ✅ on resize (debounced via rAF to avoid spam)
    let raf = 0;
    const onResize = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(update);
    };

    window.addEventListener("resize", onResize);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", onResize);
    };
  }, []);

  return (
    <GradientBlinds
      /* 🎨 Visual */
      gradientColors={["#FCA311", "#FC8421"]}
      angle={0}
      mixBlendMode="lighten"
      noise={0}

      /* 🪟 Blinds */
      blindCount={5}
      blindMinWidth={'20%'}

      /* 💡 Light / Spotlight */
      spotlightRadius={spotlightRadius}
      spotlightSoftness={0.9}
      spotlightOpacity={1}
      shineDirection="left"

      /* 🌊 Distortion */
      distortAmount={0}

      /* 🖱 Mouse Interaction */
      mouseDampening={0.5}

      /* ▶️ Auto Animation */
      autoAnimate={true}
      autoSpeed={0.5}
      pauseOnHover={true}

      /* 🧠 Advanced / Optional */
      clampDistortion={true}
      uniformHeight={false}
    />
  );
}